import {IStation} from '@core/api/data-access';

export namespace StationModelExtensionsUtils {
	export function validateStationsOrdinals<T extends IStation = IStation>(stations: T[]): T[] {
		stations.map((station, index) => {
			station['ordinal'] = index + 1;
			return validateStationName(station);
		});
		return stations;
	}

	export function validateStationName<T extends IStation = IStation>(station: T): T {
		const stationName = station['name'];
		if (!stationName || isDefaultStationName(stationName)) {
			station['name'] = window.translate('struct.station-editor.default-station-name', {value: station['ordinal']});
		}
		return station;
	}

	export function isDefaultStationName(nameToCheck): boolean {
		const regexPattern = /^(Station Number \d+|תחנה מספר \d+)$/;
		return regexPattern.test(nameToCheck);
	}
}
